<template src="./videoPage.html"></template>

<script>
import pipe from '../../../../../components/pipe/pipe.vue';
import reportMixin from '../../../../../js/reportMixin';

export default {
    name: 'video-page',
    props: ['observations', 'reportTitle',],
    components: {'pipe': pipe,},
    data() {
        return {
            connectionPoints: [],
            connectionPointsTableItems: [],
        }
    },
    computed: {
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        videoLocations() {
			return this.session.SessionVideoLocations;
		},
    },
    methods: {
        setVideos() {
            for (let i = 0; i < this.videoLocations.length; i++) {
                let videoLocation = this.videoLocations[i];
                let observationVideo = document.getElementById('observationVideo' + i); 

                videoLocation.VideoLocation =  videoLocation.VideoLocation.replace(/^https?:/, '').replace(/3.15.106.54/, window.baseURL);
                observationVideo.firstChild.src = videoLocation.VideoLocation;
                let videoLink = document.getElementById('videoLink' + i);
               
                videoLink.setAttribute('href',  videoLocation.VideoLocation);
                let indexOfUrlBase = videoLocation.VideoLocation.lastIndexOf("/");
                videoLink.innerHTML = videoLocation.VideoLocation.substring(indexOfUrlBase + 1);
                observationVideo.load();
            }		
		},
    },
    created() {
        this.$store.dispatch('SessionsModule/getSessionByID', this.session.SessionID)
			.then((response) => {
				this.$store.commit('ObservationModule/setSession', response);
			});
    },
    mounted() {
        this.setVideos();
    }
}
</script>